import React, { Fragment } from 'react';
import { ThemeProvider } from 'styled-components';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles';
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
import BaseStyle from './baseStyle';
import theme from './theme';

const Theme = ({ children }) => {
  let MuiTheme = createMuiTheme(theme);
  MuiTheme = responsiveFontSizes(MuiTheme);

  return (
    <MuiThemeProvider theme={MuiTheme}>
      <ThemeProvider theme={theme}>
        <Fragment>
          <CssBaseline />
          <BaseStyle />
          {children}
        </Fragment>
      </ThemeProvider>
    </MuiThemeProvider>
  );
};

export default Theme;
